export default "__VITE_ASSET__CfsIe6Hd__"